(function() {

    'use strict';

    /**
     * Size Guide
     * @name productSizeGuideCtrl
     * @type ProductSizeGuideCmpCtrl
     */
    var ProductSizeGuideCmp = {
        bindings: {
            product: '<',
            routeActive: '<'
        },
        controller: productSizeGuideCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'product-size-guide.component.html'
    };

    productSizeGuideCmpCtrl.$inject = [];

    function productSizeGuideCmpCtrl() {

        var _this = this;
        _this.itxHasRoute = itxHasRoute;
        _this.itxChangeRoute = itxChangeRoute;

        function itxHasRoute(route) {
            return route == _this.routeActive;
        }

        function itxChangeRoute(route) {
            _this.routeActive = route;
        }

    }

    /** Public */
    angular.module('itxApp.catalog')
        .component('productSizeGuide', ProductSizeGuideCmp);

})();